import { Loader, TextInput } from '@mantine/core';
import { modals } from '@mantine/modals';
import * as React from 'react';
import { useEffect } from 'react';
import { OpenModal } from '../../../../../../react-commons/utils/modals/openModal';
import { ResourceType } from '../../../../resource/enumerations/ResourceType';
import { useActivitiesActions } from '../../../../resource/resources/artifacts/activities/activitiesResource';

export function ReferenceTextFunction(
    modalId: string,
    objectId: string,
    versionId: string,
    resourceType: string,
    onConfirm: (name: string) => void
) {
    if (resourceType === ResourceType.ACTIVITIES) {
        OpenModal.ContentModal({
            title: 'Loading Names',
            content: (
                <ActivitiesReferenceTextComponent
                    objectId={objectId}
                    versionId={versionId}
                    onConfirm={(name) => {
                        console.log(name);
                        onConfirm(name);
                        modals.close(modalId);
                    }}
                />
            ),
            id: modalId,
        });
    }
}

const ActivitiesReferenceTextComponent = ({
    objectId,
    versionId,
    onConfirm,
}: {
    objectId: string;
    versionId: string;
    onConfirm: (name: string) => void;
}) => {
    const detailedDesignModelActions = useActivitiesActions();

    const resourceQuery = detailedDesignModelActions.useGetResourceByObjectIdAndVersionedIn(objectId, versionId);

    if (resourceQuery.data) {
        onConfirm(resourceQuery.data.name);
    }

    useEffect(() => {
        if (resourceQuery.data) {
            onConfirm(resourceQuery.data.name);
        }

        if (resourceQuery.isError) {
            onConfirm('Bad Reference');
        }
    }, [resourceQuery.isFetching, resourceQuery.data, resourceQuery.isError]);

    return <TextInput leftSection={<Loader size="sm" />} value={`Reference Names…`} readOnly />;
};
